import { createTheme, responsiveFontSizes } from '@mui/material';
import { baseTheme, BaseTheme } from './base-theme';
import componentThemeOverrides from './component-theme-overrides';

const theme: BaseTheme = createTheme({
  breakpoints: {
    ...baseTheme.breakpoints,
  },
  palette: {
    ...baseTheme.palette,
    primary: {
      main: '#2D5F4D',
    },
    secondary: {
      main: '#9DC105',
    },
    info: {
      main: '#F76443',
      contrastText: '#FFFFFF',
    },
    tertiary: {
      dark: '#d1e3bf',
      main: '#e4f5d3',
      light: '#F7FCF1',
    },
  },
  typography: {
    ...baseTheme.typography,
  },
  shape: baseTheme.shape,
});

export const inputsTheme = responsiveFontSizes(createTheme(theme, { components: componentThemeOverrides(theme) }));
